module.exports = __webpack_public_path__ + "media/hallBgm.0e2fb30d.mp3";